<style scoped>

[contenteditable]:focus {
    outline: 0px solid transparent;
}

.tab-sheet {
    font-size: 10px;
    border-top: 0.5px solid #ccc;
    border-right: 0.5px solid #ccc;
    width: 100%;
    cursor: pointer;
}

.tab-sheet.active {
    border-top: 0;
}

.tab-sheet .text {
    padding: 5px 20px 5px 20px;
}

.bottom-nav {
    position: fixed;
    z-index: 10000;
    bottom: 0;
    left: 0;
    float: left;
    width: 100%;
    background-color: #fff;
}

.bottom-nav div {
    display: block;
    float: left;
    width: auto;
    cursor: pointer;
}

.spread-sheet {
    margin-bottom: 30px;
}

.active {
    color: #78CB5B;
}

.inactive {
    color: #fff000;
}

.fa.fa-circle:before {
    content: "\25C9";
    /*color: #000;*/
}

th {
    text-align: center;
}

td:nth-child(1) {
    text-align: center;
}

td:nth-child(3) {
    text-align: center;
}

td:nth-child(2) {
    padding-left: 40px;
}

.event-active {
    font-weight: bold;
    color: #78CB5B;
    text-transform: uppercase;
    letter-spacing: 1.2px;
}

</style>

<template>

<div style="height: 100%;">
    <vue-dropzone
    id="drop1"
    style="min-height: 500px;" :options="dropOptions"
    @vdropzone-file-added="vfileAdded"
    @vdropzone-queue-complete="vqueueComplete"
    >
    Drop csv/excel files here or click to upload
  </vue-dropzone>
  <div class="text-xs-center">

    <v-dialog
      v-model="dialog"
      persistent
      width="500"
    >
      <v-card
        v-if="display == 'progress'"
        color="primary"
        dark
      >
        <v-card-text>
          {{ message }}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
      <v-card v-if="display == 'merge'">
        <v-card-title class="headline">Found similar worksheets</v-card-title>

        <v-card-text>
          <div v-for="source in relatedSources">
            Do you want to join the following worksheets ?
            <div>
              <v-chip v-for="d in source.dataSources">{{ d.name }}</v-chip>
            </div>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            flat="flat"
            @click="dialog = false; reload();"
          >
            No
          </v-btn>

          <v-btn
            color="green darken-1"
            flat="flat"
            @click="dialog = false; iMerge();"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
  </div>
</div>

</template>

<script>

import VueDropzone from "vue2-dropzone";
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

import {
    createNamespacedHelpers
}
from 'vuex'
const {
    mapState, mapActions, mapGetters, mapMutations
} = createNamespacedHelpers('dataSources')

const dataSourceNamespace = createNamespacedHelpers('dataSources');
const chartNamespace = createNamespacedHelpers('charts');
import ApiService from "@/services/api.service";

export default {
    data: function() {
        let params = this.$route.params;
        let url = ApiService.getBaseUrl() + "/files/" + params.projectId + "/uploadFile";
        return {
            display: 'progress',
            message: '',
            dialog: false,
            mergeDialog: false,
            dropOptions: {
                url: url,
                headers: ApiService.getHeader(),
                maxFilesize: 500, // MB
                maxFiles: 10,
                timeout: 900000, // 15 minutes
                acceptedFiles: ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            }
        }
    },
    name: 'charts',
    components: {
        'vue-dropzone': VueDropzone
    },
    computed: {
        ...mapState(['dataSources', 'dataSource', 'relatedSources', 'relatedSourcesFound'])
    },
    methods: {
      ...dataSourceNamespace.mapMutations(['mSetRelatedSources', 'mAdd', 'mSetDataSource', 'mSetName', 'mSetType', 'mDelete', 'mSave', 'mSetProjectId']),
      ...dataSourceNamespace.mapActions(['aGetDataSources', 'aAdd', 'aSetDataSource', 'aInit', 'aUpdate', 'aDelete', 'aMerge']),
      updateName: function(event) {
        this.mSetName(event.target.innerText);
      },
      iMerge: async function() {
        this.message = 'Merging worksheets';
        this.display = "progress";
        this.dialog = true;

        await this.aMerge(this.relatedSources);
        this.dialog = false;
        await this.aInit();


        this.$router.push({name: 'boards', params: {projectId: this.$route.params.projectId}})

      },
      reload: async function() {
        await this.aInit();
        this.dialog = false;
      },
      vsuccessMultiple(files, response) {
        this.mSetProjectId(this.$route.params.projectId);
        this.aInit();
      },
      async vqueueComplete(file, xhr, formData) {
        this.queueComplete = true;
        this.mSetProjectId(this.$route.params.projectId);
        let dataSources = await this.aGetDataSources();
        this.dialog = false;
        this.mSetRelatedSources(dataSources);
      //  console.log(dataSources);
      //  console.log(this.relatedSources);
      //
        //this.dialog = true;
      //  this.mergeDialog = true;


        // if(this.relatedSourcesFound) {
        //   this.display = "merge";
        //   this.dialog = true;
        //
        // } else {
        //   this.aInit();
        // }

        this.aInit();

        // console.log(formData);
      },
      vfileAdded(file) {
        this.message = "Importing file(s)";
        this.display = "progress";
        this.dialog = true;
      // window.toastr.info('', 'Event : vdropzone-files-added')
      }
    },
    mounted: function() {
        // console.log("mounted");
    },
    beforeCreate: function() {

    }
}

</script>
